// extracted by mini-css-extract-plugin
export default {"lds-grid":"Loading_lds-grid__WOb+N","middle":"Loading_middle__4C5Rw"};